import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
	FormControl,
	Box,
	MenuItem,
	Select,
	InputLabel,
	Button,
	Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const carrierType = [
	"Aviation",
	"Train",
	"Buses",
	"Ferris/Ship",
	"Hotels",
	"Entire Market",
	"Entire Region",
];

export default function TypesOfRights({ formik }) {
	const [selectedOptions, setSelectedOptions] = React.useState(
		formik.values.carrierType
	);
	const preSelectedAirline = formik.values.airline?.map(
		(airLineOperatorName) => {
			return { operatorName: airLineOperatorName };
		}
	);
	const [airlineType, setAirlineType] = React.useState("");
	const [countryCode, setCountryCode] = React.useState("");
	const [selectedAirline, setSelectedAirline] =
		React.useState(preSelectedAirline);
	const airlineOptions = useSelector(
		(state) => state.contentForm.airlineOptions
	);

	const handleChange = (event, newValue) => {
		if (newValue.includes("All")) {
			if (selectedOptions?.length !== carrierType.length - 1) {
				setSelectedOptions(
					carrierType.filter((option) => option !== "All")
				);
				formik.setFieldValue(
					"carrierType",
					carrierType.filter((option) => option !== "All")
				);
			} else {
				setSelectedOptions([]);
			}
		} else {
			setSelectedOptions(newValue);
			formik.setFieldValue("carrierType", newValue);
		}
	};

	const handleAirlineTypeChange = (event) => {
		setAirlineType(event.target.value);
	};

	const handleAirlineSelect = (event, value) => {
		setSelectedAirline(value);
		const operatorNames = value?.map((airline) => airline?.operatorName);
		formik.setFieldValue("airline", operatorNames);
	};

	const handleCountryCode = (e) => {
		setCountryCode(e.target.value);
	};

	// const handleAirlineSearch = async () => {
	//   try {
	//     setLoading(true);
	//     const response = await fetch(
	//       `https://applications.icao.int/dataservices/api/code-list?api_key=27039776-074b-4422-af51-e5549e1ed061&format=json&states=${countryCode}`
	//     );
	//     const data = await response.json();
	//     dispasetAirlineOptions(data);
	//   } catch (error) {
	//   } finally {
	//     setLoading(false);
	//   }
	// };
	React.useEffect(() => {
		if (formik.values.carrierType.length === 0) {
			setSelectedOptions([]);
		}
	}, [formik.values.carrierType]);
	return (
		<FormControl fullWidth>
			<Box sx={{ margin: "10px 0" }}>
				<label htmlFor="carrierType">
					Carrier Type
					<span style={{ color: "red", marginLeft: "5px" }}>*</span>
				</label>
			</Box>
			<Box sx={{ width: "100%" }}>
				<Autocomplete
					multiple
					id="carrierType"
					options={carrierType}
					value={selectedOptions}
					onChange={handleChange}
					disableCloseOnSelect
					renderOption={(props, option, { selected }) => (
						<li {...props}>
							<Checkbox
								icon={icon}
								checkedIcon={checkedIcon}
								style={{ marginRight: 8 }}
								checked={
									option === "All"
										? selectedOptions.length ===
										  carrierType.length - 1
										: selected
								}
							/>
							{option}
						</li>
					)}
					renderInput={(params) => (
						<TextField
							style={{ width: "100%" }}
							fullWidth
							{...params}
							placeholder="Carrier Type"
						/>
					)}
				/>
			</Box>
			{formik.touched.carrierType && formik.errors.carrierType && (
				<Typography sx={{ color: "red" }}>
					{formik.errors.carrierType}
				</Typography>
			)}
			{
				// <>
				// 	{selectedOptions?.includes("Aviation") && (
				// 		<Box sx={{ marginTop: "10px" }}>
				// 			<label htmlFor="carrierType">
				// 				Airline
				// 				<span style={{ color: "red", marginLeft: "5px" }}>
				// 					*
				// 				</span>
				// 			</label>
				// 			{
				// 				  <Select
				// 				  labelId="airline-type-label"
				// 				  id="airlineType"
				// 				  placeholder="Select Airline Type"
				// 				  value={airlineType}
				// 				  onChange={handleAirlineTypeChange}
				// 				  fullWidth
				// 				>
				// 				  {/* <MenuItem value="Private Airline">Private Airline</MenuItem> */}
				// 				  <MenuItem value="Commercial Airline">Commercial Airline</MenuItem>
				// 				</Select>
				// 			}
				// 		</Box>
				// 	)}
				// 	{selectedOptions?.includes("Aviation") &&
				// 	airlineOptions.length > 0 ? (
				// 		<>
				// 			<Autocomplete
				// 				multiple
				// 				disablePortal
				// 				fullWidth
				// 				onChange={handleAirlineSelect}
				// 				value={selectedAirline}
				// 				sx={{ mt: 2 }}
				// 				id="combo-box-demo"
				// 				getOptionLabel={(option) => option.operatorName}
				// 				options={airlineOptions}
				// 				renderInput={(params) => (
				// 					<TextField {...params} fullWidth />
				// 				)}
				// 				renderOption={(props, option) => {
				// 					return <p {...props}>{option.operatorName}</p>;
				// 				}}
				// 			/>
				// 			{formik.touched.airline && formik.errors.airline && (
				// 				<Typography sx={{ color: "red" }}>
				// 					{formik.errors.airline}
				// 				</Typography>
				// 			)}
				// 		</>
				// 	) : null}
				// </>
			}
		</FormControl>
	);
}
